import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getInitials(displayName: string): string {
  const trimmed = displayName.trim()

  if (trimmed.includes('@')) {
    const prefix = trimmed.split('@')[0] ?? ''
    const parts = prefix.split(/[._-]/).filter(Boolean)
    return parts.map(p => p[0]).join('').toUpperCase().slice(0, 2)
  }

  const parts = trimmed.split(/\s+/)
  return parts.map(p => p[0]).join('').toUpperCase().slice(0, 2)
}

export function getDisplayRoles(roles: string[]): string {
  if (!roles || roles.length === 0) return ''
  return roles.join(', ')
}

export function isUrl(value: unknown): value is string {
  if (typeof value !== 'string') return false
  return /^https?:\/\//.test(value)
}

export function tryParseJson(value: string): unknown | undefined {
  const trimmed = value.trim()
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return undefined
  try {
    return JSON.parse(trimmed)
  } catch {
    return undefined
  }
}
